import { render, staticRenderFns } from "./editTabKerja.vue?vue&type=template&id=6141e6eb"
import script from "./editTabKerja.vue?vue&type=script&lang=js"
export * from "./editTabKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports